import React from 'react';
import { Icon } from './Icon.js';
export const IconRectLayoutGrid3Filled = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m14,2H6c-2.206,0-4,1.794-4,4v8c0,2.206,1.794,4,4,4h8c2.206,0,4-1.794,4-4V6c0-2.206-1.794-4-4-4ZM4,14v-6h3v8h-1c-1.103,0-2-.897-2-2Zm10,2h-5v-8h7v6c0,1.103-.897,2-2,2Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconRectLayoutGrid3Filled.js.map